import { Grid, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { TabPanel } from "../../common/components/functional/tabpanel/TabPanel";
import { FormContainer } from "../customer/customerManagement/styles";
import { AccountsControlPanel } from "./AccountsControlPanel";
import { ExpenseTypesControlPanel } from "./expenseTypes/ExpenseTypesControlPanel";
import { SalesAccountsControlPanel } from "./salesAccounts/SalesAccountsControlPanel";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const AccountingMainPage = () => {
  const { t } = useTranslation("settings");
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event: SyntheticEvent, newTabIndex: number) => {
    setTabIndex(newTabIndex);
  };

  return (
    <FormContainer>
      <Grid item xs={12} sx={{ mb: 3 }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 700,
            },
          }}
        >
          <Tab label={t("expenseTypes")} {...a11yProps(0)} />
          <Tab label={t("salesAccounts")} {...a11yProps(1)} />
          <Tab label={t("accountsAndIncomeTypes")} {...a11yProps(2)} />
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <TabPanel value={tabIndex} index={0}>
          <ExpenseTypesControlPanel />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <SalesAccountsControlPanel />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <AccountsControlPanel />
        </TabPanel>
      </Grid>
    </FormContainer>
  );
};
